import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { ReactNode } from 'react';
import { TOKEN_KEY } from '../config/api';
import { needsSignupResume } from '../utils/needsSignupResume';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isLoading, user } = useAuth();
  const token = localStorage.getItem(TOKEN_KEY);
  const hasToken = !!token;

  if (isLoading) {
    // Return a generic loading skeleton
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#F8F7EC] to-[#E8F1D1] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#7E8D4C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#6b6358]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  // Same rules as OnboardingGate: providers complete at level 3, patients at 5.
  // Do not hardcode level 5 for everyone — that blocked My Team for finished doctors.
  if (needsSignupResume(user)) {
    return <Navigate to="/signup" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
